<template>
  <div>
    <div class="row">
      <div class="col-12">
        <b-overlay :show="loadingSuppression">
          <ListFilter ref="filters" />
        </b-overlay>
        <ListRow
          v-for="item in suppressions"
          :item="item.source"
          :key="item.id"
          v-on:deleted="handleDeleted"
        />
        <b-overlay :show="loadingSuppression">
          <ListPagination />
        </b-overlay>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import ListRow from './ListRow';
import ListFilter from './ListFilter';
import ListPagination from './ListPagination';

import { updateSearchParams } from '@/febos/global/utils/router';

export default {
  name: 'ListDetail',
  props: ['filter'],
  components: {
    ListFilter,
    ListRow,
    ListPagination
  },
  data() {
    return {
      page: parseInt(this.$route.query.page, 10) || 1,
      filters: []
    };
  },
  watch: {
    async page(page) {
      updateSearchParams({ page });
      await this.debounceFetchByRut();
    },
    async filters() {
      await this.debounceFetchByRut();
    },
    filter(val) {
      this.manageFilter(val);
    }
  },
  computed: {
    ...mapGetters('Emails', ['loadingSuppression', 'suppressions'])
  },
  methods: {
    handleDeleted() {
      this.$refs.filters.appliFilters();
    }
  }
};
</script>
